import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store'
import { i18n } from '@/extend'
import View from '@/components/lib/View'
import auth from '@/services/auth'
import { languageFallback, languages } from '@/const/shared'

Vue.use(VueRouter)

const beforeEnterLang = (to, from, next) => {
  const langParam = to.params.lang
  const langFound = languages.find(el => el.url === langParam)

  if (langFound) {
    if (i18n.locale !== langFound.locale) {
      i18n.locale = languages.find(lang => lang.url === langParam).locale
    }
    next()
  } else {
    next({ name: to.name, params: { lang: languageFallback.url } })
  }
}

const routes = [
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  {
    path: '/:lang',
    component: View,
    beforeEnter: beforeEnterLang,
    meta: { public: true },
    children: [
      {
        name: 'Home',
        path: '',
        redirect: { name: 'Calendar' }
      },
      {
        name: 'AutoLogin',
        path: 'autologin',
        meta: { public: true },
        component: () => import(/* webpackChunkName: "login" */ '@/views/AutoLogin')
      },
      {
        name: 'Login',
        path: 'login',
        meta: { public: true },
        component: () => import(/* webpackChunkName: "login" */ '@/views/Login')
      },
      {
        name: 'Logout',
        path: 'logout',
        meta: { public: true },
        component: () => import(/* webpackChunkName: "login" */ '@/views/Logout')
      },
      {
        name: 'AdminPanel',
        path: 'admin-panel',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminPanel')
      },
      {
        name: 'Onboarding',
        path: 'onboarding',
        component: () => import(/* webpackChunkName: "onboarding" */ '@/views/Onboarding')
      },
      {
        name: 'Calendar',
        path: 'calendar',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Calendar')
      },
      {
        name: 'CreateAppointment',
        path: 'create-appointment',
        component: () => import(/* webpackChunkName: "home" */ '@/views/CreateAppointment')
      },
      {
        name: 'EditAppointment',
        path: 'edit-appointment/:appointmentId',
        component: () => import(/* webpackChunkName: "home" */ '@/views/EditAppointment')
      },
      {
        name: 'Settings',
        path: 'settings',
        redirect: { name: 'ShopSettings' },
        component: () => import(/* webpackChunkName: "settings" */ '@/views/Settings'),
        children: [
          {
            name: 'CalendarSettings',
            path: 'calendar',
            alias: '',
            component: () => import(/* webpackChunkName: "settings" */ '@/views/CalendarSettings')
          },
          {
            name: 'ShopSettings',
            path: 'shop',
            alias: '',
            component: () => import(/* webpackChunkName: "settings" */ '@/views/ShopSettings')
          },
          {
            name: 'ServicesSettings',
            path: 'services',
            component: () => import(/* webpackChunkName: "settings" */ '@/views/ServicesSettings')
          }
        ]
      },
      {
        name: 'Manage',
        path: 'manage',
        redirect: { name: 'BookingForm' },
        component: () => import(/* webpackChunkName: "manage" */ '@/views/Manage'),
        children: [
          {
            name: 'BookingForm',
            path: 'booking-form',
            alias: '',
            component: () => import(/* webpackChunkName: "manage" */ '@/views/BookingForm')
          }
        ]
      },
      {
        name: 'Account',
        path: 'account',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Account')
      },
      {
        name: 'Reports',
        path: 'reports',
        component: () => import(/* webpackChunkName :"home" */ '@/views/ReportsPage')
      },
      {
        name: 'ResetPassword',
        path: 'reset-password',
        meta: { public: true },
        component: () => import(/* webpackChunkName: "resetpassword" */ '@/views/ResetPassword')
      }
    ]
  },
  {
    path: '*',
    redirect: { name: 'Home' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => !record.meta.public)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!localStorage.getItem('apollo-token')) {
      await auth.logout()
      store.commit('RESET_STORE')
      beforeEnterLang({ name: 'Login', params: { lang: to.params.lang } }, from, next)
    } else next()
  } else {
    next() // does not require auth, make sure to always call next()!
  }
})

export default router
